import React, { useEffect } from "react";
import TitleHeader from "../components/title_header";

const useHeaderTitle = (setheader, title) => {
    useEffect(() => {
        if (setheader) {
            setheader(<TitleHeader title={title} />);
        }
    }, [setheader, title]);
};

export default useHeaderTitle;

